import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'src/app/services/connection.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-lombard-ckyc',
  templateUrl: './lombard-ckyc.page.html',
  styleUrls: ['./lombard-ckyc.page.scss'],
})
export class LombardCkycPage implements OnInit {

  userDetails: any;
  ckycForm: FormGroup;
  showConditionalFields: boolean = true;
  showDocsUploadSection: boolean = false;
  isSingleProof: any;
  correlationId: string;

  idAddrProofPreviewUrl: any = "";
  idProofPreviewUrl: any = "";
  addrProofPreviewUrl: any = "";

  idAddrProofFile: any;
  idProofFile: any;
  addrProofFile: any;

  idAddrProofType: any;
  idProofType: any;
  addrProofType: any;

  constructor(
    private fb: FormBuilder,
    private strg: StorageService,
    private datePipe: DatePipe,
    private apiService: ConnectionService,
    private toast: ToastService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.strg.getStoreData("icici_finalRes").then(res => {
      console.log("icici_finalRes-icici_finalRes-icici_finalRes", res);
      this.correlationId = res.serverQuoteRequest.CorrelationId;
      console.log("correlationId", this.correlationId);
    });

    this.strg.getStoreData("userObj").then(res => {
      this.userDetails = res;
      console.log("user details", this.userDetails)
    })

    this.route.params.subscribe(params => {
      let pageId = params['id'];
      if(pageId == "1") {
        this.showDocsUploadSection = false;
      } else if(pageId =="2"){
        this.showDocsUploadSection = true;
      }
    });

    this.ckycForm = this.fb.group({
      "ckycId": [''],
      "pan": ['', [Validators.required, Validators.pattern("^([a-zA-Z]){3}([cptfhCPTFH]){1}([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}?$")]],
      "dob": ['', [Validators.required]],
      "pepFlag": [false, [Validators.required]],
    });
  }

  initiateLombardCkyc() {
    let data = {
      "panNumber": (this.ckycForm.get("pan").value).toUpperCase(),
      "dob": this.datePipe.transform(this.ckycForm.get("dob").value, "dd-MM-yyyy"),
      "pepFlag": this.ckycForm.get("pepFlag").value,
      "correlationId": this.correlationId
    }
    this.loader.showLoader();
    this.apiService.searchLombardVehicleCkyc(data).subscribe(res => {
      this.loader.hideLoader();
      console.log("res", res);
      if (res.data.message.includes("No record found")) {
        // this.showDocsUploadSection = true;
        this.router.navigate(['/lombard-ckyc/2']);
      } else if (res.data.message.includes("Date of birth entered does not match")) {
        this.toast.showToast("DOB entered does not match with PAN. Please enter correct DOB")
      } else if (res.data.statusMessage === "Success" && res.data.kyc_details?.il_kyc_ref_no) {
        this.toast.showToast("CKYC Successful. Now redirecting to Proposal Form")
        this.proceedToProposalForm(res.data, data);
      }
    }, err => {
      this.loader.hideLoader();
      console.log("err", err);
    });
  }

  handleDocsCount(event) {
    if (this.isSingleProof === "NO") {
      this.idAddrProofFile = undefined;
      this.idAddrProofPreviewUrl = "";
    } else {
      this.idProofFile = undefined;
      this.idProofPreviewUrl = undefined;
      this.addrProofFile = undefined;
      this.addrProofPreviewUrl = undefined;
    }
  }

  selectIdAddrProof() {
    document.getElementById("idAddrProof").click();
  }

  selectIdProof() {
    document.getElementById("idProof").click();
  }
  
  selectAddrProof() {
    document.getElementById("addrProof").click();
  }

  readFilesURL(files: Event, label): void {
    if (label === 'idAddrProof') {
      if (files && files[0]) {
        this.idAddrProofFile = files[0];
        const reader = new FileReader();
        reader.onload = e => {
          this.idAddrProofPreviewUrl = reader.result;
          console.log("Reader result", reader.result);
        }
        reader.readAsDataURL(this.idAddrProofFile);
      }
    } else if (label === 'idProof') {
      if (files && files[0]) {
        this.idProofFile = files[0];
        const reader = new FileReader();
        reader.onload = e => {
          this.idProofPreviewUrl = reader.result;
          console.log("Reader result", reader.result);
        }
        reader.readAsDataURL(this.idProofFile);
      }
    } else if (label === 'addrProof') {
      if (files && files[0]) {
        this.addrProofFile = files[0];
        const reader = new FileReader();
        reader.onload = e => {
          this.addrProofPreviewUrl = reader.result;
          console.log("Reader result", reader.result);
        }
        reader.readAsDataURL(this.addrProofFile);
      }
    }
  }

  submitCkycData() {
    let data = {
      correlationId: this.correlationId,
      // email: this.userDetails.email,
      email: "asdads@asdasd.com",
      // mobile: "91"+this.userDetails.phoneNumber,
      mobile: "919898989898",
      pepFlag: this.ckycForm.get("pepFlag").value,
      isSameDoc: this.isSingleProof === "YES" ? true : false,
    }

    if (this.isSingleProof === "YES") {
      data["poaDocumentType"] = this.idAddrProofType;
      data["poaDocument"] = this.idAddrProofFile;
    } else {
      data["poiDocumentType"] = this.idProofType;
      data["poiDocument"] = this.idProofFile;
      data["poaDocumentType"] = this.addrProofType;
      data["poaDocument"] = this.addrProofFile;
    }

    console.log("req body", data);

    this.apiService.lombardVehicleOvdUpload(data).subscribe(res => {
      console.log("lombard ovd res", res);
      if (res.data.statusMessage === "ACCEPTED_FOR_MANUAL_QC" && res.data.kyc_details?.il_kyc_ref_no) {
        this.toast.showToast("Document uploaded successfully. Now redirecting to Proposal Form")
        this.proceedToProposalForm(res.data, data);
      }
    }, err => {
      console.log("error msg", err);
      this.toast.showToast(err.error.message);
    })
  }

  goback() {
    this.router.navigate(["/lombard-ckyc/1"]);
  }

  proceedToProposalForm(data, data1) {
    data["apiReqData"] = data1;
    this.strg.setStoreData("LombardGenCkycData", data).then(res => {
      this.router.navigate(["/vehicle-proposal-form"]);
    })
  }

}
